<template>
    <div class="backoffice requests">
        <b-container fluid>
            <b-row>
                <b-col cols="10" offset="1">
                    <div class="requests--topbar">
                        <div class="requests--filters">
                            <div class="requests--filter">
                                <b-form-input 
                                    placeholder="S-ID"
                                    type="text" 
                                    size="sm"
                                    v-model="current_sid"
                                ></b-form-input>
                                <div class="requests--remove" v-if="current_sid !== ''"
                                    @click="() => {
                                        page = 1
                                        current_sid = ''
                                        delete filter.sid
                                        get_structures_paginated_from_api()
                                    }"
                                ></div>
                                <b-button class="service-btn" variant="success" size="sm" 
                                            @click="() => {
                                                page = 1
                                                filter.pid = current_sid
                                                get_structures_paginated_from_api()
                                            }" title="ricerca">
                                    <font-awesome-icon icon="search" />
                                </b-button>

                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_name !== '' ? current_name : 'nome struttura'"
                                    :variant="(current_name == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_name"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_name" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.name = current_name
                                                get_structures_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_name !== ''"
                                    @click="() => {
                                        page = 1
                                        current_name = ''
                                        delete filter.name
                                        get_structures_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_banconista_id !== '' ? banconiste.filter(function(b){ return b.banconiste_id == current_banconista_id })[0].display_name : 'agente'"
                                    :variant="(current_banconista_id === '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_banconista_id"
                                >
                                    <b-dropdown-item v-for="(banconista, index) in banconiste" v-bind:key="'key_current_banconista_id_' + index">
                                        <div v-html="banconista.display_name"
                                            @click="() => 
                                                {
                                                    page = 1
                                                    current_banconista_id = banconista.banconiste_id
                                                    filter.banconiste_id = banconista.banconiste_id
                                                    get_structures_paginated_from_api()
                                                }
                                            "
                                        ></div>
                                    </b-dropdown-item>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_banconista_id !== ''"
                                    @click="() => {
                                        page = 1
                                        current_banconista_id = ''
                                        delete filter.banconiste_id
                                        get_structures_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                        </div>
                        <div class="requests--filter">
                            <b-dropdown
                                :text="show_deleted_structures_criteria.filter(function(o) { return o.slug == show_deleted_structures })[0].friendly"
                                :variant="(show_deleted_structures == 0)? 'secondary' : 'danger'"
                                size="sm"
                                ref="trashed"
                            >
                                <b-dropdown-item v-for="(order,index) in show_deleted_structures_criteria" v-bind:key="'key_show_deleted_structures_' + index">
                                    <div v-html="order.friendly"
                                        @click="() => {
                                            page = 1
                                            show_deleted_structures = order.slug
                                            filter.trashed = order.slug
                                            get_structures_paginated_from_api()
                                        }"
                                    >
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>


                        <div class="requests--filter">
                            <b-dropdown
                                :text="current_order_by !== '' ? order_criteria.filter(function(o) { return o.slug == current_order_by })[0].friendly  : 'ordina'"
                                :variant="(current_order_by == '')? 'secondary' : 'success'"
                                size="sm"
                                ref="sort"
                            >
                                <b-dropdown-item v-for="(order,index) in order_criteria" v-bind:key="'key_current_order_by_' + index">
                                    <div
                                        v-html="order.friendly"
                                        @click="() => {
                                            page = 1
                                            current_order_by = order.slug
                                            filter.sort = order.slug
                                            get_structures_paginated_from_api()
                                        }"
                                    >
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="requests--filter">
                          <select v-model="records_per_page" @change="() => {
                                            page = 1
                                            get_structures_paginated_from_api()
                                        }">
                            <option v-for="(option, index) in records_per_page_options" :value="option" v-bind:key="'key_records_per_page_' + index">
                              {{ option }}
                            </option>
                          </select>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid v-if="!loading">
            <div v-if="results.data.length">


                <table class="requests--table">
                  <tr>
                    <th :class="'requests--id th-sort ' + has_filter('id')" @click="sort_by('id')">S-ID</th>

                    <th :class="'requests--name th-sort ' + has_filter('name')" @click="sort_by('name')">nome struttura</th>

                    <th :class="'requests--created th-sort ' + has_filter('created_at')" @click="sort_by('created_at')">creata il</th>

                    <th :class="'requests--agent ' + has_filter('banconista_display_name')" >agent</th>

                    <th :class="'requests--lastmod th-sort ' + has_filter('updated_at')" @click="sort_by('updated_at')">ultima modifica</th>

                    <th class="requests--buttons"></th>
                  </tr>
                  <tr v-for="structure in results.data" v-bind:key="'key_id_' + structure.id">
                    <td class="requests--id">
                      S-{{ structure.id }}
                    </td>

                    <td class="requests--name" v-html="structure.name"></td>

                    <td class="requests--created">
                      {{ structure.created_at | moment("DD-MM-YYYY HH:mm") }}
                    </td>

                    <td class="requests--agent" v-html="structure.banconista_display_name"></td>

                    <td class="requests--lastmod">
                      <div v-if="structure.updated_at != structure.created_at">
                        {{structure.updated_at | moment("DD-MM-YYYY HH:mm") }}
                      </div>
                    </td>

                    <td class="requests--buttons">
                      <!--<history v-if="history_enabled" :id="structure.id" />
                      <request-messages :request_id="request.request_id" />-->
                      <div>
                        <div v-if="!show_deleted_structures">
                                <b-button class="service-btn" size="sm" v-b-modal="'structures_'+structure.id">
                                    <font-awesome-icon icon="pen" />
                                </b-button>

                                <b-modal ref="structureModal" :id="'structures_'+structure.id" :title="'Modifica Struttura (' + structure.name + ')'" size="xl" hide-footer>
                                  <structures 
                                    :struttura_id="structure.id"
                                    @closeModalStructures="(value) => closeModalStructures({
                                        id: 'structures_'+structure.id
                                    })"
                                  />
                                </b-modal>

                          <b-button class="service-btn" variant="danger" size="sm" @click="trash_structure(structure.id)">
                                    <font-awesome-icon icon="trash" />
                          </b-button>
                        </div>
                        <div v-else>
                          <b-button class="service-btn" variant="success" size="sm" @click="restore_a_structure(structure.id)" title="ripristina">
                              <font-awesome-icon icon="retweet" />
                          </b-button>
                        </div>
                          <!--<b-button class="service-btn" size="sm" @click="self_unassign_soldquote(structure.id)">libera</b-button>-->
                      </div>
                    </td>
                  </tr>
                </table>

                <b-row>
                    <b-col cols="10" offset="1">
                        <pagination
                            :data="results"
                            @pagination-change-page="(page) => {
                                this.page = page
                                this.get_structures_paginated_from_api()
                            }"
                        >
                            <template #prev-nav>
                                <strong>&lt;</strong>
                            </template>
                            <template #next-nav>
                                <strong>&gt;</strong>
                            </template>
                        </pagination>
                    </b-col>
                </b-row>

            </div>
            <div v-else>
                <b-row>
                    <b-col cols="10" offset="1">
                        <p>nessuna struttura</p>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>    
</template>

<script>
    import Vue from 'vue'
    import LaravelVuePagination from 'laravel-vue-pagination';
    import Structures from '@/components/blocks/structures'
    import {get_structures_paginated, delete_structure, restore_structure} from '@/api'
    /* import History from '@/components/blocks/history' */

    export default {
        name: 'listing_structures',
        components: {
          'pagination': LaravelVuePagination,
          'structures': Structures,
          /* 'history': History, */
        },
        data() {
            return {
                loading: true,
                results: {},
                page: 1,

                records_per_page: 25,
                records_per_page_options: [10, 25, 50, 100],
                filter: {
                    //request_status: "assigned"
                    'sort': 'updated_at.desc'
                },
                current_sid: '',
                current_status: '',
                current_name: '',
                current_confirm_code: '',
                current_banconista_id: '',
                current_name_surname: '',
                current_email: '',
                current_order_by: 'updated_at.desc',
                order_criteria: [
                    {
                        friendly: 'Dal meno recente',
                        slug: 'created_at.asc',
                    },
                    {
                        friendly: 'Dal più recente',
                        slug: 'created_at.desc',
                    },
                    {
                      friendly: 'Modifiche recenti',
                      slug: 'updated_at.desc',
                    },

                ],
                show_deleted_structures: 0,
                show_deleted_structures_criteria: [
                    {
                        friendly: 'Strutture cestinate',
                        slug: 1,
                    },
                    {
                        friendly: 'Strutture attive',
                        slug: 0,
                    },
                ],
                banconiste: [
                    {banconiste_id: Vue.prototype.$config.user.profile.id, display_name: 'MIE'},
                    {banconiste_id: 0, display_name: 'NON ASSEGNATE'},
                    ...Vue.prototype.$config.banconiste
                ],
                my_banconiste_id: Vue.prototype.$config.user.profile.id,
                history_enabled: (Vue.prototype.$config.config.history_enabled)? true : false,
            }
        },
        computed: {
        },
        created()
        {
            this.get_structures_paginated = get_structures_paginated
        },
        mounted() {
            this.get_structures_paginated_from_api()
        },
        methods:{
          closeModalStructures(param)
          {
            this.$bvModal.hide(param.id)
          },
          get_structures_paginated_from_api()
          {
              this.loading = true
              get_structures_paginated({
                  page: this.page,
                  records_per_page:this.records_per_page,
                  filter: this.filter,
                  sort: this.sort,
              })
                  .then((data) => {
                      this.results = data.result
                      this.loading = false
                  })
          },

            get_request_status(status)
            {
              let status_variant = 'info'

              if(status == 'open') status_variant = 'info'
              if(status == 'assigned') status_variant = 'warning'
              if(status == 'working') status_variant = 'warning'
              if(status == 'booked') status_variant = 'success'

              return status_variant
            },

            sort_by(slug)
            {
              if (this.filter.sort == slug+'.asc')
              {
                this.filter.sort = slug+'.desc'
              }
              else if (this.filter.sort == slug+'.desc')
              {
                this.filter.sort = slug+'.asc'
              }
              else
              {
                this.filter.sort = slug+'.asc'
              }
              this.get_structures_paginated_from_api()
            },

            has_filter(slug)
            {
              if (this.filter.sort == slug+'.asc') return 'active asc'
              if (this.filter.sort == slug+'.desc') return 'active desc'
              return ''
            },

            trash_structure(id) //lmbo973 - trash soldquote
            {

                if(!confirm('Vuoi eliminare la struttura S-'+id+'?')) return
                Vue.$toast.info('elimino S-' + id)
                delete_structure({ id: id})
                    .then((success) => {
                        (success)
                        Vue.$toast.success('struttura cestinata')
                        this.$router.go()
                    })
            },

            restore_a_structure(id)
            {

                if(!confirm('Vuoi ripristinare la struttura S-'+id+'?')) return
                Vue.$toast.info('ripristino S-' + id)
                restore_structure({ id: id})
                    .then((success) => {
                        (success)
                        Vue.$toast.success('struttura ripristinata')
                        this.$router.go()
                    })
            },

        },
    }
</script>

<style lang="scss">
.requests
{
  width:100%;
  margin-left: 0;
  .request-row
  {
    &:nth-child(odd)
    {
      background-color:rgba(200,200,200,0.2);
    }
    padding:0.75rem 0;
    display:flex;
    align-items: center;
  }
  .pagination
  {
    margin:60px auto;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  &--topbar
  {
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:20px;
  }
  &--filters
  {
    display:flex;
    align-items: center;
    flex:1;
  }
  &--filter
  {
    margin-right:1rem;
    display:flex;
    align-items: center;
    .dropdown-menu
    {
      overflow:hidden;
    }
    .b-dropdown-form
    {
      display:flex;
      input
      {
        min-width: 160px;
        border:0;
      }
      button
      {

      }
    }
  }
  &--remove
  {
    width:24px;
    height:24px;
    cursor:pointer;
    color:$info;
    position:relative;
    &:after
    {
      content:"x";
      position:absolute;
      top:50%;
      left:50%;
      transform:translateY(-50%) translateX(-50%);
    }
  }
  &--wrapper
  {
    max-width:100%;
    overflow-x:scroll;
  }
  &--table
  {
    width:100%;
    font-size:12px;
    .badge
    {
      font-size: 100%;
    }
    td,th
    {
      white-space: nowrap;
      padding:10px 16px;
    }
    th
    {
      text-align:left;
      padding:10px 16px;
    }
    .th-sort
    {
      cursor:pointer;
      transition:$transition-base;
      &:after
      {
        content: "";
        display:inline-block;
        margin-left:8px;
        width:10px;
        text-align: center;
      }
      &.active,
      &:hover
      {
        color:$cta;
      }
      &.active
      {
        &:after
        {
          content:">";
        }
        &.asc:after
        {
          transform:rotate(-90deg);
        }
        &.desc:after
        {
          transform:rotate(90deg);
        }
      }
    }
    tr:nth-child(odd):not(:nth-child(1))
    {
      background:rgba($gray-200,0.5);
    }
    tr:nth-child(1)
    {
      background:rgba($gray-200,1);
    }
  }
  &--id
  {
    .btn
    {
      display:flex;
      width:100%;
      align-items: center;
      justify-content: space-between;
      svg
      {
        margin-left:8px;
      }
    }
  }
  &--travel
  {
    text-align: center;
  }
  &--productcode
  {

  }
  &--confirmcode
  {

  }
  &--title
  {
    max-width: 20ch;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &--status
  {
  }
  &--agent
  {
  }
  &--created
  {

  }
  &--customer
  {

  }
  &--company
  {

  }
  &--budget
  {

  }
  &--availability
  {

  }
  &--lastmod
  {
  }
  &--buttons
  {
    display:flex;
    align-items: center;
    &>*
    {
      margin-right:12px;
    }
  }

}
</style>